import { computed } from 'vue';

import { useRulesStore } from '@/store/rules';
import { useCalculationEngine } from '../composables/useCalculationEngine';

import { fixNumbers } from '../utils/math';

export function useCalculatorSummaryEstimated(calculatorId: number) {
  const rulesStore = useRulesStore();

  const { evalRulesWithExpression } = useCalculationEngine();

  const rules = computed(() => {
    return rulesStore.data
      ?.filter(
        (rule) =>
          rule.ruleable_id === calculatorId &&
          rule.type === 'tile' &&
          !!rule.is_visible &&
          rule.parent_id === null
      )
      .map((rule) => {
        const evalWithExpression = evalRulesWithExpression(rule.rules);

        return {
          ...rule,
          eval:
            rule.unit === '%'
              ? (Number(evalWithExpression.eval) * 100).toFixed(2)
              : fixNumbers(evalWithExpression.eval),
          expression: evalWithExpression.expression,
        };
      });
  });

  return {
    rules,
  };
}
